import { render } from "./FeedbackListView.vue?vue&type=template&id=8a73883c&scoped=true"
import script from "./FeedbackListView.vue?vue&type=script&lang=js"
export * from "./FeedbackListView.vue?vue&type=script&lang=js"

import "./FeedbackListView.vue?vue&type=style&index=0&id=8a73883c&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a73883c"]])

export default __exports__